import ContactsBaseDetailsPageController from './base';
import contactModelReducer from '../../../../../pages/contacts/helpers/contact-model-reducer';

export default class ContactsEditPageController extends ContactsBaseDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.depositService = this.injector.get('Deposit');
        this.usersStore = this.injector.get('Users');
        this.acl = this.injector.get('Acl');

        this.deposits = {
            countries: {},
            languages: {},
            genders: {}
        }
        this.schema = null;
        this.store = this.stateParams.store;
        this.model = null;
        this.originalModel = null;
    }

    $onInit() {
        this._loadDeposits();
        this._setupEditor();
        super.$onInit();
    }

    _contactUpdatedActions() {
        super._contactUpdatedActions();

        this.model = contactModelReducer(this.contact);
        this.originalModel = _.cloneDeep(this.model);

        this.headline = `Edit Contact Details ${this.model.title} ${this.model.first_name} ${this.model.last_name}`;
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', [])
            .then((value) => {
                this.deposits.countries = _.merge({'': ''}, value);
            });
        this.depositService.getRemoteDeposit('contacts', 'languages', [])
            .then((value) => {
                this.deposits.languages = value;
            });
        this.depositService.getRemoteDeposit('contacts', 'genders', [])
            .then((value) => {
                this.deposits.genders = value;
            });
    }

    _setupEditor() {
        this.mediaDirectoryUuid = _.get(this.usersStore, 'state.company.media.default_directories.contacts', null);
        this.enableShippingAddress = _.get(this.usersStore, 'state.company.settings.contacts.enable_shipping_address');

        this.injector.get('Contact')
            .getSchema()
            .then((schema) => {
                this.schema = schema;
            });
    }

    save(mode, form) {
        if (!form.$valid) {
            Alert.error('Invalid data', 'Please recheck your inputs');
            return;
        }
        return this.api.put(`contacts/${this.contact.id}`, this.prepareModelForApi())
            .then(contact => {
                let deferred = this.injector.get('$q')
                    .resolve(contact);

                this.model = contact;
                return deferred.then(contact => {
                    if (this.store) {
                        this.store.dispatch('getData');
                    }

                    this.alert.success('Success', 'Changes have been saved');
                    this.cancel(contact);
                });
            }, response => this.alert.handle(response));
    }

    cancel() {
        this.state.go('app.contacts.details.overview', {
            id: this.stateParams.id,
            contact: null
        }, {
            reload: true
        });
    }

    prepareModelForApi() {
        const out = _.cloneDeep(this.model);

        for (let i = 1; i <= 40; i++) {
            const currentField = _.get(this.schema.properties, 'custom_' + i, null);
            if (currentField) {
                if ((currentField.original.type === 'date' || currentField.original.type === 'datetime') && !_.get(out, 'custom_' + i)) {
                    out['custom_' + i] = null;
                }
            }
        }

        return out;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/edit.js